// MCP Server Templates Catalog
// Extracted from McpTab.vue for maintainability

export const mcpServerTemplates = [
  // Google Services
  {
    id: 'google-calendar',
    name: 'Google Calendar',
    description:
      'Gerenciar eventos, criar reunioes e consultar agenda do Google Calendar',
    icon: 'i-lucide-calendar',
    category: 'google',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@anthropic/mcp-server-google-calendar'],
    requiredEnv: [
      {
        key: 'GOOGLE_CLIENT_ID',
        label: 'Google Client ID',
        placeholder: 'seu-client-id.apps.googleusercontent.com',
        type: 'text',
      },
      {
        key: 'GOOGLE_CLIENT_SECRET',
        label: 'Google Client Secret',
        placeholder: 'GOCSPX-...',
        type: 'password',
      },
      {
        key: 'GOOGLE_REFRESH_TOKEN',
        label: 'Google Refresh Token',
        placeholder: 'Token de refresh OAuth',
        type: 'password',
      },
    ],
    documentation:
      'https://developers.google.com/calendar/api/quickstart/python',
  },
  {
    id: 'google-drive',
    name: 'Google Drive',
    description: 'Acessar, buscar e gerenciar arquivos no Google Drive',
    icon: 'i-lucide-hard-drive',
    category: 'google',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@anthropic/mcp-server-google-drive'],
    requiredEnv: [
      {
        key: 'GOOGLE_CLIENT_ID',
        label: 'Google Client ID',
        placeholder: 'seu-client-id.apps.googleusercontent.com',
        type: 'text',
      },
      {
        key: 'GOOGLE_CLIENT_SECRET',
        label: 'Google Client Secret',
        placeholder: 'GOCSPX-...',
        type: 'password',
      },
      {
        key: 'GOOGLE_REFRESH_TOKEN',
        label: 'Google Refresh Token',
        placeholder: 'Token de refresh OAuth',
        type: 'password',
      },
    ],
    documentation: 'https://developers.google.com/drive/api/quickstart/python',
  },
  {
    id: 'gmail',
    name: 'Gmail',
    description: 'Ler, enviar e gerenciar emails do Gmail',
    icon: 'i-lucide-mail',
    category: 'google',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@anthropic/mcp-server-gmail'],
    requiredEnv: [
      {
        key: 'GOOGLE_CLIENT_ID',
        label: 'Google Client ID',
        placeholder: 'seu-client-id.apps.googleusercontent.com',
        type: 'text',
      },
      {
        key: 'GOOGLE_CLIENT_SECRET',
        label: 'Google Client Secret',
        placeholder: 'GOCSPX-...',
        type: 'password',
      },
      {
        key: 'GOOGLE_REFRESH_TOKEN',
        label: 'Google Refresh Token',
        placeholder: 'Token de refresh OAuth',
        type: 'password',
      },
    ],
    documentation: 'https://developers.google.com/gmail/api/quickstart/python',
  },
  {
    id: 'google-sheets',
    name: 'Google Sheets',
    description: 'Ler e escrever dados em planilhas do Google Sheets',
    icon: 'i-lucide-table',
    category: 'google',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@anthropic/mcp-server-google-sheets'],
    requiredEnv: [
      {
        key: 'GOOGLE_CLIENT_ID',
        label: 'Google Client ID',
        placeholder: 'seu-client-id.apps.googleusercontent.com',
        type: 'text',
      },
      {
        key: 'GOOGLE_CLIENT_SECRET',
        label: 'Google Client Secret',
        placeholder: 'GOCSPX-...',
        type: 'password',
      },
      {
        key: 'GOOGLE_REFRESH_TOKEN',
        label: 'Google Refresh Token',
        placeholder: 'Token de refresh OAuth',
        type: 'password',
      },
    ],
    documentation: 'https://developers.google.com/sheets/api/quickstart/python',
  },
  // Development Tools
  {
    id: 'github',
    name: 'GitHub',
    description:
      'Gerenciar repositorios, issues, pull requests e codigo no GitHub',
    icon: 'i-lucide-github',
    category: 'development',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-github'],
    requiredEnv: [
      {
        key: 'GITHUB_PERSONAL_ACCESS_TOKEN',
        label: 'GitHub Token',
        placeholder: 'ghp_xxxxxxxxxxxx',
        type: 'password',
      },
    ],
    documentation: 'https://github.com/settings/tokens',
  },
  {
    id: 'gitlab',
    name: 'GitLab',
    description: 'Gerenciar repositorios, issues e merge requests no GitLab',
    icon: 'i-lucide-git-branch',
    category: 'development',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-gitlab'],
    requiredEnv: [
      {
        key: 'GITLAB_PERSONAL_ACCESS_TOKEN',
        label: 'GitLab Token',
        placeholder: 'glpat-xxxxxxxxxxxx',
        type: 'password',
      },
      {
        key: 'GITLAB_API_URL',
        label: 'GitLab URL (opcional)',
        placeholder: 'https://gitlab.com/api/v4',
        type: 'text',
      },
    ],
    documentation:
      'https://docs.gitlab.com/ee/user/profile/personal_access_tokens.html',
  },
  {
    id: 'linear',
    name: 'Linear',
    description: 'Gerenciar issues, projetos e sprints no Linear',
    icon: 'i-lucide-layout-list',
    category: 'development',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-linear'],
    requiredEnv: [
      {
        key: 'LINEAR_API_KEY',
        label: 'Linear API Key',
        placeholder: 'lin_api_xxxxxxxxxxxx',
        type: 'password',
      },
    ],
    documentation: 'https://linear.app/settings/api',
  },
  {
    id: 'jira',
    name: 'Jira',
    description: 'Gerenciar issues, sprints e projetos no Jira',
    icon: 'i-lucide-trello',
    category: 'development',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-jira'],
    requiredEnv: [
      {
        key: 'JIRA_HOST',
        label: 'Jira Host',
        placeholder: 'your-domain.atlassian.net',
        type: 'text',
      },
      {
        key: 'JIRA_EMAIL',
        label: 'Jira Email',
        placeholder: 'seu@email.com',
        type: 'text',
      },
      {
        key: 'JIRA_API_TOKEN',
        label: 'Jira API Token',
        placeholder: 'Token de API do Jira',
        type: 'password',
      },
    ],
    documentation:
      'https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/',
  },
  // Communication
  {
    id: 'slack',
    name: 'Slack',
    description: 'Enviar mensagens, ler canais e gerenciar workspace do Slack',
    icon: 'i-lucide-message-square',
    category: 'communication',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-slack'],
    requiredEnv: [
      {
        key: 'SLACK_BOT_TOKEN',
        label: 'Slack Bot Token',
        placeholder: 'xoxb-xxxxxxxxxxxx',
        type: 'password',
      },
      {
        key: 'SLACK_TEAM_ID',
        label: 'Slack Team ID',
        placeholder: 'T0XXXXXXX',
        type: 'text',
      },
    ],
    documentation: 'https://api.slack.com/apps',
  },
  {
    id: 'discord',
    name: 'Discord',
    description: 'Enviar mensagens e interagir com servidores Discord',
    icon: 'i-lucide-message-circle',
    category: 'communication',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-discord'],
    requiredEnv: [
      {
        key: 'DISCORD_BOT_TOKEN',
        label: 'Discord Bot Token',
        placeholder: 'Token do bot Discord',
        type: 'password',
      },
    ],
    documentation: 'https://discord.com/developers/applications',
  },
  {
    id: 'telegram',
    name: 'Telegram',
    description: 'Enviar e receber mensagens via Telegram Bot',
    icon: 'i-lucide-send',
    category: 'communication',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-telegram'],
    requiredEnv: [
      {
        key: 'TELEGRAM_BOT_TOKEN',
        label: 'Telegram Bot Token',
        placeholder: '123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11',
        type: 'password',
      },
    ],
    documentation: 'https://core.telegram.org/bots#botfather',
  },
  // Search & Web
  {
    id: 'brave-search',
    name: 'Brave Search',
    description: 'Pesquisar na web usando a API do Brave Search',
    icon: 'i-lucide-search',
    category: 'search',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-brave-search'],
    requiredEnv: [
      {
        key: 'BRAVE_API_KEY',
        label: 'Brave API Key',
        placeholder: 'BSA...',
        type: 'password',
      },
    ],
    documentation: 'https://brave.com/search/api/',
  },
  {
    id: 'google-search',
    name: 'Google Search',
    description: 'Pesquisar na web usando a API do Google Custom Search',
    icon: 'i-lucide-globe',
    category: 'search',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-google-search'],
    requiredEnv: [
      {
        key: 'GOOGLE_API_KEY',
        label: 'Google API Key',
        placeholder: 'AIza...',
        type: 'password',
      },
      {
        key: 'GOOGLE_CSE_ID',
        label: 'Custom Search Engine ID',
        placeholder: 'ID do mecanismo de pesquisa',
        type: 'text',
      },
    ],
    documentation:
      'https://developers.google.com/custom-search/v1/introduction',
  },
  {
    id: 'serper',
    name: 'Serper (Google SERP)',
    description:
      'Pesquisar no Google via Serper API com resultados estruturados',
    icon: 'i-lucide-search-code',
    category: 'search',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-serper'],
    requiredEnv: [
      {
        key: 'SERPER_API_KEY',
        label: 'Serper API Key',
        placeholder: 'Chave da API Serper',
        type: 'password',
      },
    ],
    documentation: 'https://serper.dev/',
  },
  // Web Scraping & Browser
  {
    id: 'puppeteer',
    name: 'Puppeteer (Web Scraping)',
    description: 'Navegar em sites, fazer scraping e automatizar browsers',
    icon: 'i-lucide-globe-2',
    category: 'automation',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-puppeteer'],
    requiredEnv: [],
    documentation: 'https://pptr.dev/',
  },
  {
    id: 'playwright',
    name: 'Playwright (Browser Automation)',
    description: 'Automacao avancada de browser com Playwright',
    icon: 'i-lucide-monitor',
    category: 'automation',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@anthropic/mcp-server-playwright'],
    requiredEnv: [],
    documentation: 'https://playwright.dev/',
  },
  {
    id: 'firecrawl',
    name: 'Firecrawl',
    description: 'Web scraping avancado com conversao para Markdown',
    icon: 'i-lucide-flame',
    category: 'automation',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@anthropic/mcp-server-firecrawl'],
    requiredEnv: [
      {
        key: 'FIRECRAWL_API_KEY',
        label: 'Firecrawl API Key',
        placeholder: 'fc-...',
        type: 'password',
      },
    ],
    documentation: 'https://firecrawl.dev/',
  },
  // Databases
  {
    id: 'postgres',
    name: 'PostgreSQL',
    description: 'Consultar e gerenciar bancos de dados PostgreSQL',
    icon: 'i-lucide-database',
    category: 'database',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-postgres'],
    requiredEnv: [
      {
        key: 'POSTGRES_CONNECTION_STRING',
        label: 'Connection String',
        placeholder: 'postgresql://user:pass@host:5432/db',
        type: 'password',
      },
    ],
    documentation: 'https://www.postgresql.org/docs/current/libpq-connect.html',
  },
  {
    id: 'mysql',
    name: 'MySQL',
    description: 'Consultar e gerenciar bancos de dados MySQL',
    icon: 'i-lucide-database',
    category: 'database',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-mysql'],
    requiredEnv: [
      {
        key: 'MYSQL_HOST',
        label: 'Host',
        placeholder: 'localhost',
        type: 'text',
      },
      { key: 'MYSQL_PORT', label: 'Porta', placeholder: '3306', type: 'text' },
      {
        key: 'MYSQL_USER',
        label: 'Usuario',
        placeholder: 'root',
        type: 'text',
      },
      {
        key: 'MYSQL_PASSWORD',
        label: 'Senha',
        placeholder: 'senha',
        type: 'password',
      },
      {
        key: 'MYSQL_DATABASE',
        label: 'Database',
        placeholder: 'nome_do_banco',
        type: 'text',
      },
    ],
    documentation: 'https://dev.mysql.com/doc/',
  },
  {
    id: 'mongodb',
    name: 'MongoDB',
    description: 'Consultar e gerenciar bancos de dados MongoDB',
    icon: 'i-lucide-leaf',
    category: 'database',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-mongodb'],
    requiredEnv: [
      {
        key: 'MONGODB_URI',
        label: 'MongoDB URI',
        placeholder: 'mongodb://user:pass@host:27017/db',
        type: 'password',
      },
    ],
    documentation:
      'https://www.mongodb.com/docs/manual/reference/connection-string/',
  },
  {
    id: 'redis',
    name: 'Redis',
    description: 'Gerenciar cache e dados no Redis',
    icon: 'i-lucide-zap',
    category: 'database',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-redis'],
    requiredEnv: [
      {
        key: 'REDIS_URL',
        label: 'Redis URL',
        placeholder: 'redis://user:pass@host:6379',
        type: 'password',
      },
    ],
    documentation: 'https://redis.io/docs/connect/clients/',
  },
  {
    id: 'sqlite',
    name: 'SQLite',
    description: 'Consultar bancos de dados SQLite locais',
    icon: 'i-lucide-file-box',
    category: 'database',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-sqlite'],
    requiredEnv: [
      {
        key: 'SQLITE_DB_PATH',
        label: 'Caminho do Banco',
        placeholder: '/path/to/database.db',
        type: 'text',
      },
    ],
    documentation: 'https://www.sqlite.org/docs.html',
  },
  // Storage & Files
  {
    id: 'filesystem',
    name: 'Filesystem',
    description: 'Ler e escrever arquivos no sistema de arquivos local',
    icon: 'i-lucide-folder',
    category: 'storage',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-filesystem', '/allowed/path'],
    requiredEnv: [
      {
        key: 'ALLOWED_DIRECTORIES',
        label: 'Diretorios Permitidos',
        placeholder: '/home/user/documents,/tmp',
        type: 'text',
      },
    ],
    documentation: 'https://modelcontextprotocol.io/docs/servers/filesystem',
  },
  {
    id: 'aws-s3',
    name: 'AWS S3',
    description: 'Gerenciar arquivos em buckets do Amazon S3',
    icon: 'i-lucide-cloud',
    category: 'storage',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-aws-s3'],
    requiredEnv: [
      {
        key: 'AWS_ACCESS_KEY_ID',
        label: 'AWS Access Key ID',
        placeholder: 'AKIA...',
        type: 'text',
      },
      {
        key: 'AWS_SECRET_ACCESS_KEY',
        label: 'AWS Secret Key',
        placeholder: 'Chave secreta AWS',
        type: 'password',
      },
      {
        key: 'AWS_REGION',
        label: 'AWS Region',
        placeholder: 'us-east-1',
        type: 'text',
      },
      {
        key: 'S3_BUCKET',
        label: 'S3 Bucket',
        placeholder: 'nome-do-bucket',
        type: 'text',
      },
    ],
    documentation: 'https://docs.aws.amazon.com/s3/',
  },
  {
    id: 'dropbox',
    name: 'Dropbox',
    description: 'Acessar e gerenciar arquivos no Dropbox',
    icon: 'i-lucide-box',
    category: 'storage',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-dropbox'],
    requiredEnv: [
      {
        key: 'DROPBOX_ACCESS_TOKEN',
        label: 'Dropbox Access Token',
        placeholder: 'Token de acesso Dropbox',
        type: 'password',
      },
    ],
    documentation: 'https://www.dropbox.com/developers/apps',
  },
  // CRM & Business
  {
    id: 'notion',
    name: 'Notion',
    description: 'Gerenciar paginas, databases e conteudo no Notion',
    icon: 'i-lucide-book-open',
    category: 'productivity',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-notion'],
    requiredEnv: [
      {
        key: 'NOTION_API_KEY',
        label: 'Notion API Key',
        placeholder: 'secret_...',
        type: 'password',
      },
    ],
    documentation: 'https://developers.notion.com/',
  },
  {
    id: 'airtable',
    name: 'Airtable',
    description: 'Gerenciar bases e registros no Airtable',
    icon: 'i-lucide-grid-3x3',
    category: 'productivity',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-airtable'],
    requiredEnv: [
      {
        key: 'AIRTABLE_API_KEY',
        label: 'Airtable API Key',
        placeholder: 'pat...',
        type: 'password',
      },
      {
        key: 'AIRTABLE_BASE_ID',
        label: 'Base ID',
        placeholder: 'app...',
        type: 'text',
      },
    ],
    documentation: 'https://airtable.com/developers/web/api/introduction',
  },
  {
    id: 'hubspot',
    name: 'HubSpot',
    description: 'Gerenciar contatos, deals e CRM no HubSpot',
    icon: 'i-lucide-users',
    category: 'crm',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-hubspot'],
    requiredEnv: [
      {
        key: 'HUBSPOT_ACCESS_TOKEN',
        label: 'HubSpot Access Token',
        placeholder: 'Token de acesso HubSpot',
        type: 'password',
      },
    ],
    documentation: 'https://developers.hubspot.com/',
  },
  {
    id: 'salesforce',
    name: 'Salesforce',
    description: 'Gerenciar leads, oportunidades e CRM no Salesforce',
    icon: 'i-lucide-cloud-lightning',
    category: 'crm',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-salesforce'],
    requiredEnv: [
      {
        key: 'SALESFORCE_INSTANCE_URL',
        label: 'Instance URL',
        placeholder: 'https://yourorg.salesforce.com',
        type: 'text',
      },
      {
        key: 'SALESFORCE_ACCESS_TOKEN',
        label: 'Access Token',
        placeholder: 'Token de acesso Salesforce',
        type: 'password',
      },
    ],
    documentation: 'https://developer.salesforce.com/',
  },
  // AI & Knowledge
  {
    id: 'memory',
    name: 'Memory (Knowledge Graph)',
    description:
      'Armazenar e recuperar informacoes em um grafo de conhecimento',
    icon: 'i-lucide-brain',
    category: 'ai',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-memory'],
    requiredEnv: [],
    documentation: 'https://modelcontextprotocol.io/docs/servers/memory',
  },
  {
    id: 'qdrant',
    name: 'Qdrant (Vector DB)',
    description: 'Busca vetorial e RAG com Qdrant',
    icon: 'i-lucide-search-check',
    category: 'ai',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-qdrant'],
    requiredEnv: [
      {
        key: 'QDRANT_URL',
        label: 'Qdrant URL',
        placeholder: 'http://localhost:6333',
        type: 'text',
      },
      {
        key: 'QDRANT_API_KEY',
        label: 'Qdrant API Key (opcional)',
        placeholder: 'Chave da API',
        type: 'password',
      },
    ],
    documentation: 'https://qdrant.tech/documentation/',
  },
  {
    id: 'pinecone',
    name: 'Pinecone (Vector DB)',
    description: 'Busca vetorial e RAG com Pinecone',
    icon: 'i-lucide-target',
    category: 'ai',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-pinecone'],
    requiredEnv: [
      {
        key: 'PINECONE_API_KEY',
        label: 'Pinecone API Key',
        placeholder: 'Chave da API Pinecone',
        type: 'password',
      },
      {
        key: 'PINECONE_ENVIRONMENT',
        label: 'Environment',
        placeholder: 'us-west1-gcp',
        type: 'text',
      },
      {
        key: 'PINECONE_INDEX',
        label: 'Index Name',
        placeholder: 'my-index',
        type: 'text',
      },
    ],
    documentation: 'https://docs.pinecone.io/',
  },
  // Finance & Payments
  {
    id: 'stripe',
    name: 'Stripe',
    description: 'Gerenciar pagamentos, clientes e subscricoes no Stripe',
    icon: 'i-lucide-credit-card',
    category: 'finance',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-stripe'],
    requiredEnv: [
      {
        key: 'STRIPE_SECRET_KEY',
        label: 'Stripe Secret Key',
        placeholder: 'sk_live_...',
        type: 'password',
      },
    ],
    documentation: 'https://stripe.com/docs/api',
  },
  // Analytics & Monitoring
  {
    id: 'sentry',
    name: 'Sentry',
    description: 'Monitorar erros e performance com Sentry',
    icon: 'i-lucide-alert-triangle',
    category: 'monitoring',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-sentry'],
    requiredEnv: [
      {
        key: 'SENTRY_AUTH_TOKEN',
        label: 'Sentry Auth Token',
        placeholder: 'Token de autenticacao',
        type: 'password',
      },
      {
        key: 'SENTRY_ORG',
        label: 'Organization Slug',
        placeholder: 'my-org',
        type: 'text',
      },
    ],
    documentation: 'https://docs.sentry.io/api/',
  },
  // E-commerce
  {
    id: 'shopify',
    name: 'Shopify',
    description: 'Gerenciar produtos, pedidos e loja no Shopify',
    icon: 'i-lucide-shopping-bag',
    category: 'ecommerce',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-shopify'],
    requiredEnv: [
      {
        key: 'SHOPIFY_STORE_URL',
        label: 'Store URL',
        placeholder: 'mystore.myshopify.com',
        type: 'text',
      },
      {
        key: 'SHOPIFY_ACCESS_TOKEN',
        label: 'Access Token',
        placeholder: 'shpat_...',
        type: 'password',
      },
    ],
    documentation: 'https://shopify.dev/docs/api',
  },
  // Time & Scheduling
  {
    id: 'time',
    name: 'Time',
    description: 'Obter data/hora atual e converter fusos horarios',
    icon: 'i-lucide-clock',
    category: 'utilities',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-time'],
    requiredEnv: [],
    documentation: 'https://modelcontextprotocol.io/docs/servers/time',
  },
  // Code & Development
  {
    id: 'fetch',
    name: 'Fetch (HTTP Client)',
    description: 'Fazer requisicoes HTTP para APIs externas',
    icon: 'i-lucide-globe',
    category: 'utilities',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-fetch'],
    requiredEnv: [],
    documentation: 'https://modelcontextprotocol.io/docs/servers/fetch',
  },
  {
    id: 'sequential-thinking',
    name: 'Sequential Thinking',
    description: 'Raciocinio passo-a-passo para problemas complexos',
    icon: 'i-lucide-list-ordered',
    category: 'ai',
    transport: 'stdio',
    command: 'npx',
    args: ['-y', '@modelcontextprotocol/server-sequential-thinking'],
    requiredEnv: [],
    documentation:
      'https://modelcontextprotocol.io/docs/servers/sequential-thinking',
  },
];

export const categories = [
  { id: 'all', name: 'Todos', icon: 'i-lucide-layers' },
  { id: 'google', name: 'Google', icon: 'i-lucide-chrome' },
  { id: 'development', name: 'Desenvolvimento', icon: 'i-lucide-code' },
  {
    id: 'communication',
    name: 'Comunicacao',
    icon: 'i-lucide-message-square',
  },
  { id: 'search', name: 'Pesquisa', icon: 'i-lucide-search' },
  { id: 'automation', name: 'Automacao', icon: 'i-lucide-bot' },
  { id: 'database', name: 'Banco de Dados', icon: 'i-lucide-database' },
  { id: 'storage', name: 'Armazenamento', icon: 'i-lucide-hard-drive' },
  {
    id: 'productivity',
    name: 'Produtividade',
    icon: 'i-lucide-check-square',
  },
  { id: 'crm', name: 'CRM', icon: 'i-lucide-users' },
  { id: 'ai', name: 'IA & Conhecimento', icon: 'i-lucide-brain' },
  { id: 'finance', name: 'Financeiro', icon: 'i-lucide-credit-card' },
  { id: 'monitoring', name: 'Monitoramento', icon: 'i-lucide-activity' },
  { id: 'ecommerce', name: 'E-commerce', icon: 'i-lucide-shopping-cart' },
  { id: 'utilities', name: 'Utilidades', icon: 'i-lucide-wrench' },
];

export const transportOptions = [
  { value: 'stdio', label: 'STDIO (Local)' },
  { value: 'sse', label: 'SSE (HTTP)' },
  { value: 'websocket', label: 'WebSocket' },
];

export const getTransportBadge = transport => {
  const badges = {
    stdio: {
      label: 'STDIO',
      class:
        'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
    },
    sse: {
      label: 'SSE',
      class: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
    },
    websocket: {
      label: 'WebSocket',
      class:
        'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
    },
  };
  return (
    badges[transport] || {
      label: transport,
      class: 'bg-gray-100 text-gray-700',
    }
  );
};

export const getCategoryColor = category => {
  const colors = {
    google: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
    development:
      'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400',
    communication:
      'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
    search:
      'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
    automation:
      'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400',
    database:
      'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
    storage:
      'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
    productivity:
      'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-400',
    crm: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400',
    ai: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
    finance:
      'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
    monitoring:
      'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400',
    ecommerce:
      'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400',
    utilities:
      'bg-slate-100 text-slate-700 dark:bg-slate-900/30 dark:text-slate-400',
  };
  return colors[category] || 'bg-gray-100 text-gray-700';
};
